module.exports = __webpack_public_path__ + "img/pallet.99007e5b.jpg";